import type { FiltersContext } from '@openx/components-filters/lib/context/types.ts';
import { FILTER_TYPES } from '@openx/components-filters/lib/FiltersBar/types.ts';
import type { Option } from '@openx/types/options.ts';
import type { TFunction } from 'i18next';
import type { AudiencesListFilters } from '../types.ts';

export type GetAudienceFiltersConfigParams = {
  t: TFunction;
  userId: string;
  isInternalOxUser: boolean;
  providerOptions: Option[];
  userOptions: Option[];
  accountOptions: Option[];
  audienceStatusOptions: Option[];
};

export const getFiltersConfig = ({
  t,
  userId,
  isInternalOxUser,
  providerOptions,
  userOptions,
  accountOptions,
  audienceStatusOptions,
}: GetAudienceFiltersConfigParams): FiltersContext<AudiencesListFilters>['filtersConfig'] => [
  {
    key: 'status',
    name: t('Status'),
    type: FILTER_TYPES.CHECKBOX,
    options: audienceStatusOptions as [Option, ...Option[]],
  },
  {
    key: 'addressable_reach',
    name: t('Reach'),
    type: FILTER_TYPES.RANGE,
    config: {
      inputType: 'integer',
      precision: 0,
      debounce: 500,
      detailedOptionsConfig: {
        minFieldPlaceholder: t('Enter Min. value'),
        maxFieldPlaceholder: t('Enter Max. value'),
      },
    },
  },
  ...(isInternalOxUser
    ? [
        {
          key: 'account' as const,
          name: t('Data Partner'),
          type: FILTER_TYPES.AUTOCOMPLETE,
          options: accountOptions,
          config: {
            selectedPlaceholder: t('[ Select Data Partner ]'),
            emptyPlaceholder: t('[ Select Data Partner ]'),
            dropdownHeight: '220px',
          },
        },
      ]
    : []),
  {
    key: 'direct_audience_provider',
    name: t('Data Provider'),
    type: FILTER_TYPES.AUTOCOMPLETE,
    options: providerOptions,
    config: {
      selectedPlaceholder: t('[ Select Data Provider ]'),
      emptyPlaceholder: t('[ Select Data Provider ]'),
      dropdownHeight: '220px',
    },
  },
  {
    key: 'updated_date',
    name: t('Data Range'),
    type: FILTER_TYPES.DATE_RANGE,
  },
  {
    key: 'createdBy',
    name: t('Created By'),
    type: FILTER_TYPES.AUTOCOMPLETE,
    options: userOptions,
    config: {
      emptyPlaceholder: t('[ Select or Search User ]'),
      selectedPlaceholder: t('[ Select or Search User ]'),
      dropdownHeight: '220px',
    },
  },
  {
    key: 'my_audiences',
    name: t('Show My Audiences'),
    type: FILTER_TYPES.SWITCH,
    options: [{ id: userId, name: userId }],
  },
];
